// helpers/rutaMovimientos.js
import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";
// const BASE_URL = "http://localhost:3004";

const getToken = () => localStorage.getItem("token") || "";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
});

// inyecta token en cada request
api.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  cfg.headers.token = getToken();
  return cfg;
});

const normError = (error, fallbackMsg) => ({
  ok: false,
  error:
    error?.response?.data ||
    error?.message ||
    fallbackMsg ||
    "Error de red",
});

/* ───────── Movimientos (lista) ─────────
   - opts.full: true -> full=1 ; false -> full=0 ; undefined -> no manda 'full'
   - podés pasar además cualquier otro query param en opts (fecha, tipo, etc.)
*/
export const getMovimientos = async (opts = {}) => {
  try {
    const { full, ...rest } = opts;
    const params =
      typeof full === "boolean"
        ? { full: full ? 1 : 0, ...rest }
        : { ...rest }; // no incluimos 'full' si no lo pedís explícito

    const resp = await api.get("/movimientos", { params });
    console.log(
      "[/movimientos] mode:",
      resp?.data?.mode,
      "warn:",
      resp?.data?.warn
    );
    return resp.data;
  } catch (error) {
    return normError(error, "Error al obtener movimientos");
  }
};

// Atajo conveniente para pedir populate sin tocar el resto del código
export const getMovimientosFull = (opts = {}) =>
  getMovimientos({ ...opts, full: true });

/* ───────── Movimiento (por id) ───────── */
export const getMovimientoById = async (id) => {
  try {
    const resp = await api.get(`/movimientos/${id}`);
    return resp.data;
  } catch (error) {
    return normError(error, "Error al obtener movimiento");
  }
};

/* ───────── Crear ───────── */
export const postMovimiento = async (movimientoData) => {
  try {
    const resp = await api.post("/movimientos", movimientoData, {
      headers: { "Content-Type": "application/json" },
    });
    return resp.data;
  } catch (error) {
    return normError(error, "Error al crear movimiento");
  }
};

/* ───────── Actualizar ───────── */
export const putMovimiento = async (id, movimientoData) => {
  try {
    const resp = await api.put(`/movimientos/${id}`, movimientoData, {
      headers: { "Content-Type": "application/json" },
    });
    return resp.data;
  } catch (error) {
    return normError(error, "Error al actualizar movimiento");
  }
};

/* ───────── Eliminar ───────── */
export const deleteMovimiento = async (id) => {
  try {
    const resp = await api.delete(`/movimientos/${id}`);
    return resp.data;
  } catch (error) {
    return normError(error, "Error al eliminar movimiento");
  }
};
